// Vuex
import store from '@/store.js';
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';

import Request from './request';

async function orders(data) {
    return Request('get', "api/top/orders", data);
}

async function materials(data) {
    return Request('get', "api/top/get-materials", data);
}

async function getMaterials(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/top/get-materials-to-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function stockMaterials(data) {
    return Request('get', "api/top/get-stock-material-warning", data);
}

async function getStockMaterials(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/top/get-stock-materials-warning-to-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function shops(data) {
    return Request('get', "api/top/shops", data);
}

async function suppliers(data) {
    return Request('get', "api/top/suppliers", data);
}

async function todos(data) {
    const response = await Request('get', "api/top/order-waiting-process", data);
    if (response.data && response.data.status.isOK()) {
        store.commit("todos", response.data);
    }
    return response;
}

async function stockCount(data) {
    return Request('get', "api/top/stock-count", data);
}

async function getNeardayShops() {
    return Request('get', 'api/top/shop-psi-warning?type=1')
}

async function getExpiredShops() {
    return Request('get', 'api/top/shop-psi-warning?type=2')
}

async function getShopPsiCount() {
    return Request('get', 'api/top/shop-psi')
}

async function noOrderShopsWarning(data) {
    return Request('get', 'api/top/noOrderShopsWarning',data)
}

async function noOrderShopsWarningExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/top/no-order-shops-warning-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function getPushErr() {
    return Request('get', 'api/top/getPushErr')
}

async function getGenerateDeliveryErr() {
    return Request('get', 'api/top/getGenerateDeliveryErr')
}

async function getDashboardData() {
    return Request('get', 'api/top/get-dashboard-data')
}


export default {
    orders,
    materials,
    getMaterials,
    stockMaterials,
    getStockMaterials,
    shops,
    suppliers,
    todos,
    stockCount,
    getNeardayShops,
    getExpiredShops,
    getShopPsiCount,
    noOrderShopsWarning,
    noOrderShopsWarningExport,
    getPushErr,
    getGenerateDeliveryErr,
    getDashboardData,
};